<template lang="pug">
    div#rnd-as-a-service-view
        mainHeader
        div.box
            div.has-text-centered
                strong.title R&D as a Service
            hr
            div.columns.is-vcentered
                div.column.is-4
                    img(:src="`${baseUrl}img/1.jpg`")
                div.column.has-text-justified
                    p Στη MindCore παρέχουμε υπηρεσίες έρευνας και ανάπτυξης προϊόντων (R&D), στον τομέα του αυτοματισμού και της ηλεκτρονικής για επαγγελματίες ή ιδιώτες. Αναλαμβάνουμε την επίλυση προβλημάτων στους τομείς εξειδίκευσης που δραστηριοποιούμαστε, παρέχοντας ολοκληρωμένες υπηρεσίες έρευνας, μελέτης και σχεδιασμού (software, hardware, mechatronics).
        Footer

</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'rnd-as-a-service',
  components: {
    MainHeader,
    Footer
  },
  data: function () {
    return {
        baseUrl: process.env.BASE_URL,
    };
  }
}
</script>

<style scoped>
/* p {
    position: relative;
    top: 50%;
    transform: translateY(-50%); 
} */


.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;

}
</style>

